/**
 * @generated SignedSource<<6875765df09ca4798a4e0be95ca73743>>
 * @relayHash 7513d6c5923d1609915a8367260c74ea
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 632c56bba03c212eda7bcb6a40acb5c811be32c9f70880d703b72d84fe6cafdf

import type { ConcreteRequest } from 'relay-runtime';
export type ResolveInlineCommentMutation$variables = {
  commentId: string;
  resolved: boolean;
};
export type ResolveInlineCommentMutation$data = {
  readonly resolveInlineComment: {
    readonly resolveProperties: {
      readonly isDangling: boolean;
      readonly resolved: boolean;
      readonly resolvedFriendlyDate: string | null;
      readonly resolvedTime: AGG$Long | null;
      readonly resolvedUser: string | null;
    } | null;
    readonly status: boolean;
  } | null;
};
export type ResolveInlineCommentMutation = {
  response: ResolveInlineCommentMutation$data;
  variables: ResolveInlineCommentMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "commentId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "resolved"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "commentId",
        "variableName": "commentId"
      },
      {
        "kind": "Literal",
        "name": "dangling",
        "value": false
      },
      {
        "kind": "Variable",
        "name": "resolved",
        "variableName": "resolved"
      }
    ],
    "concreteType": "ResolveInlineCommentPayload",
    "kind": "LinkedField",
    "name": "resolveInlineComment",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "status"
      },
      {
        "concreteType": "InlineCommentResolveProperties",
        "kind": "LinkedField",
        "name": "resolveProperties",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "resolved"
          },
          {
            "kind": "ScalarField",
            "name": "resolvedUser"
          },
          {
            "kind": "ScalarField",
            "name": "isDangling"
          },
          {
            "kind": "ScalarField",
            "name": "resolvedFriendlyDate"
          },
          {
            "kind": "ScalarField",
            "name": "resolvedTime"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ResolveInlineCommentMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ResolveInlineCommentMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "7513d6c5923d1609915a8367260c74ea",
    "id": "632c56bba03c212eda7bcb6a40acb5c811be32c9f70880d703b72d84fe6cafdf",
    "metadata": {},
    "name": "ResolveInlineCommentMutation",
    "operationKind": "mutation",
    "text": "mutation ResolveInlineCommentMutation($commentId:ID!,$resolved:Boolean!){resolveInlineComment(commentId:$commentId,resolved:$resolved,dangling:false){status,resolveProperties{resolved,resolvedUser,isDangling,resolvedFriendlyDate,resolvedTime}}}"
  }
};
})();

(node as any).hash = "9130df4a8889632221ebe5fe5a847d62";

export default node;
